export const stateName = 'mediaUpload';
export let MediaSelectType;

(function (MediaSelectType) {
  MediaSelectType["Forum"] = "forum_post";
  MediaSelectType["Item"] = "item";
  MediaSelectType["Complaint"] = "complaint";
  MediaSelectType["UserMsg"] = "user_msg";
})(MediaSelectType || (MediaSelectType = {}));